import styled, { css } from 'styled-components';

export const TestTable = styled.table`
    font-size: 18px;
    margin: 50px auto;

    td {
        padding: 5px 20px;
    }
`;

export const TestTableTr = styled.tr<{ $highlighted: boolean; $positionChanged: boolean }>`
    ${({ $highlighted, $positionChanged }) => {
        if ($positionChanged) {
            return css`
                background: burlywood;
            `;
        }

        if ($highlighted) {
            return css`
                background: mediumaquamarine;
            `;
        }

        return null;
    }}
`;

export const AddParticipantButton = styled.button`
    display: block;
    margin-left: 10px;
`;

export const PageContainer = styled.main``;

export const Buttons = styled.aside`
    display: flex;
    justify-content: flex-start;
    padding: 40px 0;
`;
